var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ResolveRequest, ResolveResponse, } from '@spotify-internal/remote-config-core';
import { getLogger, promiseTimeout, } from '@spotify-internal/remote-config-common';
const RCS_CONFIGURATION_ENDPOINT = '@webgate/remote-config-resolver/v3/configuration';
const RCS_UNAUTH_CONFIGURATION_ENDPOINT = '@webgate/remote-config-resolver/v3/unauth/configuration';
export const transportProvider = ({ transport, timeout: defaultTimeout }) => (_a) => {
    var { timeout = defaultTimeout } = _a, req = __rest(_a, ["timeout"]);
    const logger = getLogger('provider:transport');
    if (timeout === 0) {
        logger.warn('Resolving with a timeout of zero, response will be discarded.');
    }
    logger.debug('resolve context', req);
    const payload = ResolveRequest.toPayload(req);
    const isAuthorized = Boolean(req.username);
    logger.debug('User authentication state', isAuthorized);
    logger.debug('resolve request', payload);
    const request = transport
        .request(isAuthorized
        ? RCS_CONFIGURATION_ENDPOINT
        : RCS_UNAUTH_CONFIGURATION_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        payload: JSON.stringify(payload),
        responseType: 'json',
        authorize: isAuthorized,
        rejectNotOk: true,
    })
        .then(({ body }) => {
        logger.info('resolve response', body);
        return ResolveResponse.toConfiguration(body);
    })
        .catch(error => {
        logger.error('resolve error', error);
        throw error;
    });
    return promiseTimeout(request, timeout);
};
//# sourceMappingURL=transport.js.map